const styles = theme => ({
  toggleSelector: {
    maxHeight: '29px',
    '& .MuiToggleButtonGroup-grouped': {
      borderRadius: '4px',
      backgroundColor: theme.palette.secondary.contrastText,
      border: `0.063rem solid ${theme.palette.primary.textColor3}`,
      '&:hover': {
        backgroundColor: theme.palette.secondary.contrastText,
      },
      '&:not(:first-of-type)': {
        borderRadius: '4px',
        color: theme.palette.secondary.contrastText,
        borderColor: theme.palette.primary.offerMain,
        border: `0.063rem solid ${theme.palette.primary.textColor3}`,
      },
      '&:first-of-type': {
        borderRadius: '4px',
        border: `0.063rem solid ${theme.palette.primary.textColor3}`,
      },
    },
  },
  storageTitle: {
    fontFamily: theme.typography.subtitle1.fontFamily,
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.secondary.mobileActiveToggleBackground,
    marginBottom: '0.5rem',
  },
  colorTitle: {
    color: theme.palette.primary.textColor3,
    marginBottom: '0.5rem',
    display: 'flex',
  },
  storageButton: {
    padding: '5.3px',
    marginRight: '16px',
    textTransform: 'inherit',
    '&.Mui-disabled': {
      backgroundColor: theme.palette.primary.contrastText,
      border: `0.063rem solid ${theme.palette.secondary.mobileActiveToggleBackground}`,
      color: theme.palette.secondary.mobileActiveToggleBackground,
      opacity: 0.3,
    },
  },
  storageValue: {
    display: 'flex',
    alignItems: 'flex-end',
    color: theme.palette.primary.textColor3,
  },
});

export default styles;
